import * as THREE from 'three';

/**
 * Configure une texture pour un rendu HD et réaliste
 * @param texture - La texture THREE.js à configurer
 * @param options - Options de configuration
 */
export const configureHDTexture = (
  texture: THREE.Texture,
  options?: {
    anisotropy?: number;
    generateMipmaps?: boolean;
  },
) => {
  // Anisotropie maximale pour des textures nettes sous tous les angles
  // Utilise le maximum supporté par le GPU (généralement 16)
  texture.anisotropy = options?.anisotropy ?? 16;

  // Encoding correct pour les couleurs (sRGB) - compatible Three.js 0.150
  texture.encoding = THREE.sRGBEncoding;

  // Filtrage de haute qualité
  texture.minFilter = THREE.LinearMipmapLinearFilter;
  texture.magFilter = THREE.LinearFilter;

  // Génération des mipmaps pour un meilleur rendu à distance
  texture.generateMipmaps = options?.generateMipmaps ?? true;

  // Force la mise à jour de la texture
  texture.needsUpdate = true;

  return texture;
};

/**
 * Charge une texture HD avec toutes les configurations optimales
 * @param url - URL de la texture
 * @param onLoad - Callback appelé quand la texture est chargée
 */
export const loadHDTexture = (
  url: string,
  onLoad?: (texture: THREE.Texture) => void,
): THREE.Texture => {
  const loader = new THREE.TextureLoader();
  const texture = loader.load(url, (loadedTexture) => {
    configureHDTexture(loadedTexture);
    onLoad?.(loadedTexture);
  });

  // Configuration du wrapping
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.MirroredRepeatWrapping;
  texture.repeat.set(1, 1);

  return texture;
};
